// extracted by mini-css-extract-plugin
export default {"bannerComponent":"jk-z","red":"kk-z","calloutlink":"lk-z","headerTopBanner":"mk-z","bgcolorRed":"nk-z","headerTopCallout":"ok-z","searchBanner":"pk-z","hideMobile":"qk-z"};